import React, { useState, useEffect } from 'react';
import { db, storage } from '../../firebase/firebase';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { Form, Button, Container } from 'react-bootstrap';
import Select from 'react-select';
import { components } from 'react-select';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const AddLicense = () => {
  const [licenseId, setLicenseId] = useState('');
  const [softwareName, setSoftwareName] = useState('');
  const [softwareCompany, setSoftwareCompany] = useState('');
  const [licenseType, setLicenseType] = useState(''); // Subscription or Fully Paid
  const [expiryDate, setExpiryDate] = useState('');
  const [purchaseDate, setPurchaseDate] = useState('');
  const [fullPrice, setFullPrice] = useState('');
  
  const [seats, setSeats] = useState(1);
  const [seatAssignments, setSeatAssignments] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [receiptFile, setReceiptFile] = useState(null);
  const [quoteFile, setQuoteFile] = useState(null);
  const [hasSupport, setHasSupport] = useState(false); // Support availability
  const [supportDetails, setSupportDetails] = useState({ fullName: '', email: '', phone: '' });
  const navigate = useNavigate();

  // Fetch employees from Firestore
  useEffect(() => {
    const fetchEmployees = async () => {
      const querySnapshot = await getDocs(collection(db, 'employees'));
      setEmployees(querySnapshot.docs.map((doc) => ({ id: doc.id, full_name: doc.data().full_name })));
    };
    fetchEmployees();
  }, []);

  // Handle seat assignment dropdown with checkboxes
  const handleSelectChange = (selectedOptions) => {
    const selectedEmployeeIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setSeatAssignments(selectedEmployeeIds);
  };

  // Handle file uploads for receipt and quote
  const handleFileUpload = async (file, type) => {
    if (!file) return null;
    const fileRef = ref(storage, `licenses/${licenseId}/${type}/${file.name}`);
    try {
      await uploadBytes(fileRef, file);
      const fileURL = await getDownloadURL(fileRef);
      return fileURL;
    } catch (error) {
      console.error('Error uploading file:', error);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!licenseId) {
      console.error('License ID is required');
      return;
    }

    // Upload files and get URLs if files are selected
    const receiptUrl = receiptFile ? await handleFileUpload(receiptFile, 'receipt') : null;
    const quoteUrl = quoteFile ? await handleFileUpload(quoteFile, 'quote') : null;

    try {
      await addDoc(collection(db, 'licenses'), {
        license_id: licenseId,
        software_name: softwareName,
        software_company: softwareCompany,
        license_type: licenseType,
        expiry_date: licenseType === 'subscription' ? expiryDate : null,
        purchase_date: purchaseDate,
      
        full_price: fullPrice,
       
        seats: seats,
        seat_assignment: seatAssignments,
        receipt_url: receiptUrl,
        quote_url: quoteUrl,
        support: hasSupport ? supportDetails : null,
      });
      navigate('/dashboard');
    } catch (error) {
      console.error('Error adding license:', error);
    }
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  const customSingleValue = ({ data }) => (
    <div className="custom-single-value">
      {data.label}
    </div>
  );

  const customOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />
        <label>{props.label}</label>
      </components.Option>
    );
  };

  return (
    <Container className="mt-4">
      <h2 className="mb-4">הוסף רשיון חדש</h2>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>מזהה רשיון</Form.Label>
          <Form.Control
            type="text"
            placeholder="הכנס מזהה רשיון"
            value={licenseId}
            onChange={(e) => setLicenseId(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>שם התוכנה</Form.Label>
          <Form.Control
            type="text"
            placeholder="הכנס שם תוכנה"
            value={softwareName}
            onChange={(e) => setSoftwareName(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>חברה</Form.Label>
          <Form.Control
            type="text"
            placeholder="הכנס שם חברה"
            value={softwareCompany}
            onChange={(e) => setSoftwareCompany(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>סוג רשיון</Form.Label>
          <Form.Select
            value={licenseType}
            onChange={(e) => setLicenseType(e.target.value)}
            required
          >
            <option value="">בחר סוג רשיון</option>
            <option value="subscription">מנוי</option>
            <option value="fully_paid">רכישה מלאה</option>
          </Form.Select>
        </Form.Group>

        {licenseType === 'subscription' && (
          <>
            <Form.Group className="mb-3">
              <Form.Label>תאריך תפוגה</Form.Label>
              <Form.Control
                type="date"
                value={expiryDate}
                onChange={(e) => setExpiryDate(e.target.value)}
                required
              />
            </Form.Group>

           
          </>
        )}

        

        <Form.Group className="mb-3">
          <Form.Label>מחיר מלא</Form.Label>
          <Form.Control
            type="number"
            value={fullPrice}
            onChange={(e) => setFullPrice(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>תאריך רכישה</Form.Label>
          <Form.Control
            type="date"
            value={purchaseDate}
            onChange={(e) => setPurchaseDate(e.target.value)}
            required
          />
        </Form.Group>

        

        <Form.Group className="mb-3">
          <Form.Label>מספר מושבים</Form.Label>
          <Form.Control
            type="number"
            min="1"
            value={seats}
            onChange={(e) => {
              setSeats(Number(e.target.value));
              setSeatAssignments([]);
            }}
            required
          />
        </Form.Group>

        <h5>שיוך מושבים</h5>
        <Select
          isMulti
          options={employees.map(employee => ({
            value: employee.id,
            label: employee.full_name
          }))}
          onChange={handleSelectChange}
          value={seatAssignments.map(id => ({
            value: id,
            label: employees.find(emp => emp.id === id)?.full_name
          }))}
          components={{ Option: customOption, SingleValue: customSingleValue }}
          isDisabled={seatAssignments.length >= seats}
        />

        <Form.Group className="mb-3">
          <Form.Label>העלה קבלה</Form.Label>
          <Form.Control
            type="file"
            onChange={(e) => setReceiptFile(e.target.files[0])}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>העלה הצעת מחיר</Form.Label>
          <Form.Control
            type="file"
            onChange={(e) => setQuoteFile(e.target.files[0])}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check
            type="checkbox"
            label="האם יש תמיכה?"
            checked={hasSupport}
            onChange={(e) => setHasSupport(e.target.checked)}
          />
        </Form.Group>

        {hasSupport && (
          <>
            <Form.Group className="mb-3">
              <Form.Label>שם מלא</Form.Label>
              <Form.Control
                type="text"
                placeholder="הכנס שם מלא"
                value={supportDetails.fullName}
                onChange={(e) => setSupportDetails({ ...supportDetails, fullName: e.target.value })}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>אימייל</Form.Label>
              <Form.Control
                type="email"
                placeholder="הכנס אימייל"
                value={supportDetails.email}
                onChange={(e) => setSupportDetails({ ...supportDetails, email: e.target.value })}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>טלפון</Form.Label>
              <Form.Control
                type="tel"
                placeholder="הכנס טלפון"
                value={supportDetails.phone}
                onChange={(e) => setSupportDetails({ ...supportDetails, phone: e.target.value })}
                required
              />
            </Form.Group>
          </>
        )}

        <Button variant="primary" type="submit">
          הוסף רשיון
        </Button>
        <Button variant="secondary" type="button" onClick={handleCancel}>
          ביטול
        </Button>
      </Form>
    </Container>
  );
};

export default AddLicense;
